import { render, staticRenderFns } from "./Prizes2021PromoProductList.vue?vue&type=template&id=5bb19730&"
import script from "./Prizes2021PromoProductList.vue?vue&type=script&lang=js&"
export * from "./Prizes2021PromoProductList.vue?vue&type=script&lang=js&"
import style0 from "./Prizes2021PromoProductList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports